import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../Login/Login.css";
import logo from "../../assets/dr-is-in.png";

function removeBoth(k: string) {
  try {
    sessionStorage.removeItem(k);
  } catch {}
  try {
    localStorage.removeItem(k);
  } catch {}
}

function clearAllAuth() {
  [
    "admin_token",
    "admin_access_token",
    "doctor_token",
    "doctor_access_token",
    "student_token",
    "student_access_token",
    "pt_token",
    "pt_access_token",
    "access_token",
    "token",
    "role",
  ].forEach(removeBoth);
}

const RegistrationPortals: React.FC = () => {
  const year = new Date().getFullYear();

  useEffect(() => {
    // ✅ prevents “defaults to admin login” behavior caused by stale tokens/role
    clearAllAuth();
  }, []);

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={logo} alt="Doctor Is In Logo" className="login-logo" />

        <h2 className="login-title">Registration Portals</h2>
        <div className="login-tagline">Choose a registration path.</div>

        <div className="login-actions">
          <Link to="/doctor-registration" className="login-btn login-link">
            Advisor Registration
          </Link>

          {/* ✅ IMPORTANT: use a PUBLIC route that is NOT admin-guarded */}
          <Link to="/school-registration" className="login-btn login-link">
            School Registration
          </Link>

          <Link to="/contact-us" className="login-btn login-link">
            Contact Us
          </Link>

          <Link to="/login" className="login-btn login-link">
            ← Back to Login
          </Link>
        </div>

        <div className="login-footer">© {year} Doctor Is In App. All rights reserved.</div>
      </div>
    </div>
  );
};

export default RegistrationPortals;